var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2H20C21.1046 2 22 2.89543 22 4V9.25H2V4C2 2.89543 2.89543 2 4 2ZM5.75 4.5C5.75 4.08579 5.41421 3.75 5 3.75C4.58579 3.75 4.25 4.08579 4.25 4.5V6.5C4.25 6.91421 4.58579 7.25 5 7.25C5.41421 7.25 5.75 6.91421 5.75 6.5V4.5ZM8.75 4.5C8.75 4.08579 8.41421 3.75 8 3.75C7.58579 3.75 7.25 4.08579 7.25 4.5V6.5C7.25 6.91421 7.58579 7.25 8 7.25C8.41421 7.25 8.75 6.91421 8.75 6.5V4.5ZM12 6.25H19C19.4142 6.25 19.75 5.91421 19.75 5.5C19.75 5.08579 19.4142 4.75 19 4.75H12C11.5858 4.75 11.25 5.08579 11.25 5.5C11.25 5.91421 11.5858 6.25 12 6.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 10.75H2V16C2 17.1046 2.89543 18 4 18H7.5V15C7.5 14.418 7.64322 13.8651 7.89762 13.3789L7.98762 13.2068L8.16884 12.953C8.61631 12.3262 9.25981 11.8664 9.99773 11.646C10.3171 11.5507 10.6539 11.5 11 11.5H20C20.3461 11.5 20.6829 11.5507 21.0023 11.646C21.3621 11.7535 21.6988 11.9193 22 12.1346V10.75ZM5.75 13V15C5.75 15.4142 5.41421 15.75 5 15.75C4.58579 15.75 4.25 15.4142 4.25 15V13C4.25 12.5858 4.58579 12.25 5 12.25C5.41421 12.25 5.75 12.5858 5.75 13Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22672 14.0742C9.0819 14.351 9 14.6659 9 15V20.1C9 21.2046 9.89543 22.1 11 22.1H20C21.1046 22.1 22 21.2046 22 20.1V15C22 14.6659 21.9181 14.351 21.7733 14.0742L17.077 17.3616C16.1301 18.0244 14.8699 18.0244 13.923 17.3616L9.22672 14.0742Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5731 13.0833C20.3916 13.0291 20.1992 13 20 13H11C10.8008 13 10.6084 13.0291 10.4269 13.0833L14.7832 16.1327C15.2136 16.434 15.7864 16.434 16.2168 16.1327L20.5731 13.0833Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailServer);
export default __webpack_public_path__ + "static/media/mail-server.ffc88813da34b065b4fbf0475f5485de.svg";
export { ForwardRef as ReactComponent };